import { GSGraphsMock } from "./gsData.mock";
import { ICLGraphsMock } from "./iclData.mock";
import { IPGraphsMock } from "./ipData.mock";
import { PothasGhraphsMock } from "./pothasData.mock";
import { PSGraphsMock } from "./psData.mock";

export const dataMock: any = {
    ICL: ICLGraphsMock,
    IP: IPGraphsMock,
    POTASH: PothasGhraphsMock,
    PS: PSGraphsMock,
    GS: GSGraphsMock
};